import { Alert } from "@mui/material";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";

export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <Alert severity="warning" sx={{ borderRadius: 0 }} role="status">
      You're offline. Some features may be unavailable.
    </Alert>
  );
}
